import React from 'react';
import { TableBody } from '@mui/material';
import { Streamingpackage } from '../../../../../interfaces/StreamingProvider.interface';
import { isValidPrice } from '../../../../../services/util/prices/comparePrices';
import PriceTableRow from './PriceTableRow';

type PriceTableBodyProps = {
  providers: Streamingpackage[];
  isShowCheapeastActive: boolean;
  showSorted: boolean;
  isMonthlySubscriptionPrefered: boolean;
  showWithIcons: boolean;
};

const PriceTableBody: React.FC<PriceTableBodyProps> = ({
  providers,
  isShowCheapeastActive,
  showSorted,
  isMonthlySubscriptionPrefered,
  showWithIcons,
}) => {
  const renderSortedProviders = () => {
    return providers
      .sort((a: Streamingpackage, b: Streamingpackage) =>
        showSorted ? a.name.localeCompare(b.name) : 0
      )
      .map((provider: Streamingpackage) => {
        const validMonthPrice = isValidPrice(provider.monthly_price_cents)
          ? provider.monthly_price_cents / 100
          : null;
        const validYearPrice = isValidPrice(
          provider.monthly_price_yearly_subscription_in_cents
        )
          ? provider.monthly_price_yearly_subscription_in_cents / 100
          : null;

        let greenPrice: number | null = null;

        if (isMonthlySubscriptionPrefered && validMonthPrice) {
          greenPrice = validMonthPrice;
        } else if (validYearPrice) {
          greenPrice = validYearPrice;
        } else if (validMonthPrice) {
          greenPrice = validMonthPrice;
        }

        return (
          <PriceTableRow
            key={provider.id}
            greenPrice={greenPrice}
            isShowCheapeastActive={isShowCheapeastActive}
            provider={provider}
            validMonthPrice={validMonthPrice}
            validYearPrice={validYearPrice}
            showWithIcons={showWithIcons}
          />
        );
      });
  };

  return <TableBody>{renderSortedProviders()}</TableBody>;
};

export default PriceTableBody;
